import React from 'react';
import { Box } from '@legion-ui/core';

export type ModalContentType = {
  title?: string;
  content?: string;
  gap?: boolean;
  children?: React.ReactNode;
};

export const ModalContent = ({
  title,
  content,
  gap,
  children,
}: ModalContentType) => {
  return (
    <Box>
      {gap ? (
        <article className="flex items-center">
          <h3 className="text-black font-semibold w-1/3 ">{title}</h3>
          <section className="w-2/3">{children}</section>
        </article>
      ) : (
        <>
          <h3 className="text-black font-semibold w-1/3">{title}</h3>
          <p className="text-black text-opacity-75 text-sm text-justify">
            {content}
          </p>
        </>
      )}
    </Box>
  );
};
